import axios from 'axios'

const state = {
  promotions: [],
}

const mutations = {
  setPromotions (state, payload) { state.promotions = payload },
}

const actions = {
  fetchPromotionsList ({ commit, rootGetters }, meta) {
    const defaultMeta = {
      limit: 100000,
      offset: 0,
      page: 1,
    }

    meta = { ...defaultMeta, ...meta }

    return axios
      .get(rootGetters['api/promotionsList'], {
        params: meta,
      })
      .then(res => {
        commit('setPromotions', res.data.items)
        return res
      })
      // .catch(err => err)
  },
  fetchSinglePromotions ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/promotionsSingle'](id)).then(res => {
        return res
      }).catch(err => err)
  },
  createPromotions ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/promotionsCreate'], data).then(res => {
        return res
      })
      // .catch(err => err)
  },
  editPromotions ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/promotionsEdit'](id), data).then(res => {
        return res
      })
      // .catch(err => err)
  },
  removePromotions ({ rootGetters }, id) {
    return axios
      .delete(rootGetters['api/promotionsDelete'](id)).then(res => {
        return res
      })
      .catch(err => err)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
